/* eslint-disable no-param-reassign */
import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import 'semantic-ui-css/semantic.min.css';
import 'isomorphic-fetch';
import { configureStore } from '@reduxjs/toolkit';
import loggerMiddleware from '../r/shared/middleware/logger';
import rootReducer from '../r/rootReducer';
import FormBase from 'r/components/form';

const Root = ({ store }) => (
  <Provider store={store}>
    <FormBase />
  </Provider>
);

const preloadedState = {};
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(loggerMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState,
});

render(<Root store={store} />, document.getElementById('fplsFormBase'));
